import axios from '../../../../utills/axiosConfig';

export const fetchCategories = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/categories', { params });
  return res.data;
};

export const addCategory = async (category) => {
  try {
    const res = await axios.post('/categories', category);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateCategory = async (id, category) => {
  const res = await axios.put(`/categories/${id}`, category);
  return res.data;
};

export const deleteCategory = async (id) => {
  const res = await axios.delete(`/categories/${id}`);
  return res.data;
};

export const importCategoryCSV = async (formData) => {
  const { data } = await axios.post('/categories/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 